import { useEffect } from "react";
import { useSamplingGraphExport } from "./SamplingGraphExportContext";

/**
 * Registers the live Plotly graph element for PDF export (html2canvas capture).
 * We intentionally do not use Plotly.toImage — explicit width/height can clear traces
 * when layout is managed by react-plotly.
 *
 * @param {import('react').MutableRefObject<{ el?: HTMLElement } | null>} plotRef
 */
export function useSamplingPlotExportRegister(plotRef) {
  const ctx = useSamplingGraphExport();

  useEffect(() => {
    if (!ctx) return undefined;

    const api = {
      getPlotElement() {
        return plotRef.current?.el ?? null;
      },
    };

    ctx.register(api);
    return () => ctx.unregister();
  }, [ctx, plotRef]);
}
